import api from "./Axios";

export const setCookies = async () => {
  try {
    const response = await api.post("/home/cookies/");
    if (response?.data?.status === 200) {
      const { ip_address, browser_details } = response?.data?.data || {};
      if (ip_address && browser_details) {
        const expiryDate = new Date();
        expiryDate.setDate(expiryDate.getDate() + 14);
        document.cookie = `ip=${ip_address}; expires=${expiryDate.toUTCString()};`;
        document.cookie = `browserDetails=${browser_details}; expires=${expiryDate.toUTCString()};`;
      }
    }
  } catch (error) {
    // console.error("Error setting cookies:", error);
  }
};

export const declineCookies = async () => {
  try {
    const response = await api.post("/home/cookies/decline/");
  } catch (error) {}
};
